export type RefCodeValidationStatus = 'valid' | 'invalid';

export interface ReferralValidationResponse {
  valid: boolean;
  codeType?: 'user' | 'partner';
  referrerName?: string;
}

/**
 * Maps the `/v3/tsusers/validate-referral-code` response to the signup UI state (T2-5090).
 *
 * A valid partner / FREE_PLACEMENT campaign code carries no `referrerName`, so it must render as
 * "Valid!" with NO "Referred by …" line and must NOT be treated as invalid — otherwise the
 * Create Account button is disabled for codes the backend signup path actually accepts.
 * (PR #2161 review)
 */
export function mapReferralValidationResult(
  res: ReferralValidationResponse | null | undefined,
): { status: RefCodeValidationStatus; referrerName: string } {
  if (res?.valid) {
    return { status: 'valid', referrerName: res.referrerName || '' };
  }
  return { status: 'invalid', referrerName: '' };
}
